import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["panelKey", "width", "onCloseComplete", "onCloseStart", "onEsc", "onOpenComplete", "onOpenStart", "rootNode", "size", "children", "onBackdropClick"];
import { useEffect, useRef } from 'react';
import { callIfPossible } from '../../utils/functions';
import { PanelContext } from '../../context/PanelContext';
import AbstractModal from '../AbstractModal/AbstractModal';
import { ModalPanelTransition } from './ModalPanelTransition';
import { isSafari } from '../../utils/BrowserTest';
import { ModalPanelProvider } from './ModalPanelProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const inPanelContext = {
  inPanel: true,
  inModal: true
};
const overlayStylesOverrides = {
  '@media only screen and (min-width: 800px)': {
    overflowX: 'hidden'
  }
};
const formStyleOverrides = {
  display: 'flex',
  flex: '1 1 100%',
  flexDirection: 'column',
  maxHeight: '100%',
  flexGrow: 1
};
/**
 * For more details about this component please check the [Storybook page](https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-modalpanel--page).
 */
export const ModalPanel = _ref => {
  let {
      width = 700,
      onCloseComplete,
      onCloseStart,
      onEsc,
      onOpenComplete,
      onOpenStart,
      rootNode,
      size,
      children,
      onBackdropClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const autoFocusedEl = useRef(null);
  useEffect(() => {
    if (isSafari()) {
      autoFocusedEl.current = document.activeElement;
      autoFocusedEl.current.blur();
    }
    return () => {
      if (isSafari() && autoFocusedEl.current) {
        autoFocusedEl.current.focus();
      }
    };
  }, []);
  const handleOpenComplete = () => {
    callIfPossible(onOpenComplete);
    if (isSafari() && autoFocusedEl.current) {
      autoFocusedEl.current.focus();
    }
  };
  return /*#__PURE__*/_jsx(ModalPanelProvider, {
    overlayStylesOverrides: overlayStylesOverrides,
    formStylesOverrides: formStyleOverrides,
    children: /*#__PURE__*/_jsx(PanelContext.Provider, {
      value: inPanelContext,
      children: /*#__PURE__*/_jsx(AbstractModal, Object.assign({}, rest, {
        use: "sidebar",
        _dialogWidth: width,
        size: size,
        componentName: "ModalPanel",
        Transition: ModalPanelTransition,
        onOpenStart: onOpenStart,
        onOpenComplete: handleOpenComplete,
        onCloseStart: onCloseStart,
        onCloseComplete: onCloseComplete,
        rootNode: rootNode,
        onEsc: onEsc,
        onBackdropClick: onBackdropClick,
        children: children
      }))
    })
  });
};